import { NotSelected } from "../../../Constant/Setting";
import { MultiAgent } from "../../../Shared-ui/Types/MultiAgent";

export const multiAgentInitial: MultiAgent = {
    name: "",
    description: "",
    api_key: "",
    agent_ids: [],
    team_members: [],
    instructions: [],
    markdown: true,
    show_tool_calls: true,
    is_shared: false,
    model: NotSelected,
    team_mode: NotSelected,
    team_metadata: {
        streaming: true,
        enable_zeasecure: false,
        zeasecure_api_key: "",
        user_context_awareness: false,
    },
};
export const multiAgentErrInitial = {
    name: { error: "", value: false },
    description: { error: "", value: false },
    instructions: { error: "", value: false },
    zeasecure_api_key: { error: "", value: false },
    team_mode: { error: "", value: false },
    role: {
        error: "A concise description of what this agent does",
        value: false,
    },
    model: {
        error:
            "Select the provider and model that best suits your agent's needs. Different models excel at different tasks.",
        value: false,
    },
    provider: { error: "", value: false },
};
